<template>
  <div class="row">
    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_title">
          <h4>乘客資料</h4>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">姓名:</h5>
            <h5 class="col-md-8">{{ passenger.name }}</h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-2">性別:</h5>
            <h5 class="col-md-10">{{ passenger.gender }}</h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-4">乘客電話:</h5>
            <h5 class="col-md-8">{{ passenger.account }}</h5>
          </div>
          <div class="col-md-4">
            <h5 class="col-md-3">人數:</h5>
            <h5 class="col-md-9">{{ transaction.user_member }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="col-md-4">特約企業:</h5>
            <h5 class="col-md-8">{{ passenger.company }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">簽單號碼:</h5>
            <h5 class="col-md-8">{{ passenger.company_number }}</h5>
          </div>
          <div class="col-md-6">
            <h5 class="col-md-4">乘車評價:</h5>
            <h5 class="col-md-8">{{ transaction.passenger_evaluation }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <h5 class="col-md-4">成交金額:</h5>
            <h5 class="col-md-8 red_textcolor">
              {{ transaction.actual_price }} NT
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="col-md-2">上車地點:</h5>
            <h5 class="col-md-10">{{ transaction.on_location }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="col-md-2">實際下車地點:</h5>
            <h5 class="col-md-10">{{ transaction.off_location }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="col-md-2">篩選項目:</h5>
            <h5 class="col-md-10">{{ transaction.service_list }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="col-md-2">乘客備註:</h5>
            <h5 class="col-md-10">{{ transaction.passenger_note }}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h5 class="col-md-4">乘客建議或留言:</h5>
            <h5 class="col-md-8 red_textcolor">
              {{ transaction.passenger_advice }}
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    transaction: Object,
    passenger: Object,
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/transaction/components/Passenger.vue